export class VideoCallTranscriptionMessage {
    constructor(login, text, timestamp) {
        this.login = login;
        this.text = text;
        this.timestamp = timestamp;
    }
}
